import { Content } from 'src/contexts/ContentContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

import { AlertSuppressionSetting } from './AlertWithSuppressionDialog';
import { useEventConfirmationDialogSuppressionTimestamp } from './useEventConfirmationDialogSuppressionTimestamp';

export function useAbsolutePriceDropDialog(
  onOkay: () => void,
  onCancel: () => void,
  viagogoVirtualId?: string | null
) {
  const hasSellerEventAlertMutesFeature = useUserHasFeature(
    Feature.SellerEventAlertMutes
  );

  const eventLastTimeStamp = useEventConfirmationDialogSuppressionTimestamp(
    'absolutePriceDropSuppressionTimestamp',
    viagogoVirtualId
  );

  const lastTimeStamp =
    hasSellerEventAlertMutesFeature && viagogoVirtualId
      ? eventLastTimeStamp
      : null;

  const key: keyof AlertSuppressionSetting =
    'absolutePriceDropSuppressionTimestamp';
  return {
    key,
    lastTimeStamp,
    bodyText: <Content id={ContentId.AbsolutePriceDropWarning} />,
  };
}
